const description = "";

export const zavtraMeta = {
    home: {
        title: "Zavtra — Аксессуары из натуральной кожи",
        description,
        slug: "",
    },
    delivery: {
        title: "Доставка и оплата",
        description,
        slug: "p-dostavka-i-oplata",
    },
    guarantee: {
        title: "Гарантия и возврат",
        description,
        slug: "p-garantiya",
    },
    order: {
        title: "Корзина",
        description,
        slug: "order",
    },
    store: {
        title: "Наши магазины",
        description,
        slug: "p-o-magazine",
    },
    madcoins: {
        title: "Бонусная программа",
        description,
        slug: "madcoins",
    },
    wholesale: {
        title: "Оптовая продажа",
        description,
        slug: "p-optovaya-prodazha",
    },
    corporate: {
        title: "Корпоративный заказ",
        description,
        slug: "p-korporativnyy-zakaz",
    },
    personal: {
        title: "Личный кабинет",
        description,
        slug: "personal",
    },
    status: {
        title: "Проверить статус заказа",
        description,
        slug: "status",
    },
    "online-payment": {
        title: "Онлайн-оплата заказа",
        description,
        slug: "online-payment",
    },
    "document-personal": {
        title: "Согласие на обработку персональных данных клиентов — физических лиц",
        description,
        slug: "document-personal",
    },
    "document-confidentiality": {
        title: "Политика компании в отношении обработки персональных данных",
        description,
        slug: "document-confidentiality",
    },
    "document-loyalty": {
        title: "Условия и общие положения программы лояльности",
        description,
        slug: "document-loyalty",
    },
    "document-loyalty-faq": {
        title: "Программа лояльности Madrobots. Частые вопросы",
        description,
        slug: "document-loyalty-faq",
    },
};
